import { collection, doc, getCountFromServer, getDocs, query, where, writeBatch } from "firebase/firestore";

import { firestoreDb } from "../firebase";
import { COLLECTION_ID, EQUALS, PHOTOS, SUB_COLLECTION_ID } from "../constants";

const getPhotosByCollectionId = async (collectionId: string) => {
  try {
    const photos = await getDocs(query(
      collection(firestoreDb, PHOTOS),
      where(COLLECTION_ID, EQUALS, collectionId)
    ));
    return photos.docs.map((doc) => doc.data() as Photo);
  } catch (error) {
    console.error('Error getting photos by collectionId:', error);
  }
}

const getPhotosCountForSubCol = async (collectionId: string, subCollectionId: string) : Promise<number> => {
  try {
    const countSnapshot = await getCountFromServer(
      query(
        collection(firestoreDb, PHOTOS),
        where(COLLECTION_ID, EQUALS, collectionId),
        where(SUB_COLLECTION_ID, EQUALS, subCollectionId)
      )
    );
    return countSnapshot.data().count;
  } catch (error) {
    console.error('Error getting photos count for subcollection: ', error);
  }
  return 0;
}

const getPhotosCountForCol = async (collectionId: string) : Promise<number> => {
  try {
    const countSnapshot = await getCountFromServer(
      query(
        collection(firestoreDb, PHOTOS),
        where(COLLECTION_ID, EQUALS, collectionId)
      )
    );
    return countSnapshot.data().count;
  } catch (error) {
    console.error('Error getting photos count for collection: ', error);
  }
  return 0;
}

const getPhotosBySubCollectionId = async (collectionId: string, subCollectionId: string) => {
  try {
    const photos = await getDocs(query(
      collection(firestoreDb, PHOTOS),
      where(COLLECTION_ID, EQUALS, collectionId),
      where(SUB_COLLECTION_ID, EQUALS, subCollectionId)
    ));
    return photos.docs.map((doc) => doc.data() as Photo);
  } catch (error) {
    console.error('Error getting photos by collectionId and subCollectionId:', error);
  }
}

const movePhotoToSubCollection = async (photoIds: string[], subCollectionId: string) => {
  let count = 0;
  try {
    let batch = writeBatch(firestoreDb);
    for (const photoId of photoIds) {
      batch.update(doc(firestoreDb, PHOTOS, photoId), {
        subCollectionId: subCollectionId
      });
      count++;
      if (count > 350) {
        await batch.commit();
        batch = writeBatch(firestoreDb);
        count = 0;
      }
    }
    await batch.commit();
  } catch (error) {
    console.error('Error moving photo to subCollection: ', error);
  }
}

const deletePhotos = async (photoIds: string[]) => {
  let count = 0;
  try {
    let batch = writeBatch(firestoreDb);
    for (const photoId of photoIds) {
      batch.delete(doc(firestoreDb, PHOTOS, photoId));
      count++;
      if (count >= 350) {
        await batch.commit();
        batch = writeBatch(firestoreDb);
        count = 0;
      }
    }
    await batch.commit();
  } catch (error) {
    console.error('Error deleting photos: ', error);
  }
}

const PhotosService = {
  getPhotosByCollectionId,
  getPhotosBySubCollectionId,
  movePhotoToSubCollection,
  deletePhotos,
  getPhotosCountForSubCol,
  getPhotosCountForCol
}

export default PhotosService;
